import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    gridArea: 'sidemenu',
    overflow: 'hidden',

    '& .header-bar': {
      minHeight: theme.spacing(8) - 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      overflow: 'hidden',

      '& .toggle-side-menu': {
        height: '100%',
        padding: `0 ${theme.spacing(2)}px`,
        color: theme.palette.text.hint,

        '&-text': {
          fontWeight: theme.typography.fontWeightMedium,
          color: theme.palette.text.secondary,
        },
        '&-icon': {
          marginLeft: theme.spacing(1),
          color: theme.palette.text.secondary,

          '&.opened': {
            transform: 'rotate(180deg)',
          },
        },
      },
    },
    '& .modules': {
      '&-container': {
        maxHeight: '100%',
        overflow: 'auto',
      },
    },

    '& .results-search': {
      display: 'flex',
      margin: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
      color: theme.palette.text.hint,
    },

    '& .course-progress': {
      '&-container': {
        position: 'absolute',
        bottom: 0,
        right: 0,
        left: 0,
        borderTop: `solid 1px ${theme.palette.divider}`,
        backgroundColor: theme.palette.custom.background.area,
        display: 'flex',
        height: theme.spacing(8),
        padding: theme.spacing(0, 2),
        alignItems: 'center',
      },
      '&-bar': {
        flexGrow: 1,
        height: theme.spacing(1 / 2),
        backgroundColor: theme.palette.custom.surface[2],
        borderRadius: theme.spacing(1 / 2 / 2),

        '&-fill': {
          backgroundColor: theme.palette.primary.main,
          height: '100%',
          borderRadius: theme.spacing(1 / 2 / 2),
          transition: theme.transitions.create(),
        },
      },
      '&-text': {
        marginLeft: theme.spacing(2),
        color: theme.palette.primary.main,
      },
    },

    '&.open': {
      '& $drawerPaper': {
        paddingBottom: theme.spacing(8),
      },
    },

    [theme.breakpoints.up('md')]: {
      borderLeft: `solid 1px ${theme.palette.divider}`,
      backgroundColor: theme.palette.custom.background.area,
      width: '100%',

      '&.open': {
        width: 320,
        maxWidth: `calc(100vw - ${theme.spacing(6)}px)`,
        minWidth: '20vw',

        '& .header-bar': {
          padding: `0 ${theme.spacing(0)}px 0 ${theme.spacing(1) / 2}px`,
        },
      },

      '&.close': {
        width: 'auto',
        height: theme.spacing(8),
        overflow: 'hidden',
        borderBottom: `solid 1px ${theme.palette.divider}`,
      },
    },

    [theme.breakpoints.down('sm')]: {
      '& .header-bar': {
        paddingLeft: theme.spacing(1),
      },
    },
  },
  drawerPaper: {
    maxHeight: '100%',

    [theme.breakpoints.down('sm')]: {
      width: `calc(100vw - ${theme.spacing(6)}px)`,
      maxWidth: '320px',
    },
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      border: 'none',
    },
  },
}));

export default styles;
